import React from "react";
// import Window from "./Window";

import "./ErrorScreen.css";
import "./../index.css";
import Common from "../Common";

export default class ErrorScreen extends React.Component<ErrorScreen.Props, ErrorScreen.State>
{


    constructor(props: ErrorScreen.Props)
    {
        super(props)
    }



    render()
    {
        const lang = window.lang.shared.components["disconnect-message"];
        const lShared = window.lang.shared;
        const url = global.lobbyurl;

        return (
            <>
                <div id="ErrorScreen">

                    <div className="icon"></div>

                    <div className="infobox bgtex">

                        <p>{lang.text}</p>

                        <a
                            href={url}
                            target="_self"
                        >
                            <div className="button down">
                                {lShared.home}
                            </div>
                        </a>

                    </div>

                </div>

            </>

        )
    }


}


export namespace ErrorScreen
{


    export interface Props
    {

    }


    export interface State
    {

    }


}